import { useEffect, useState } from "react";
import { useAppContext } from "../../context/AppContext";
import { LibraryTrans } from "../../utils/translations";
import { getLibraryFolders } from "../../services/libraryService";
import { Link } from "react-router-dom";

const Library = () => {
  const { language, token } = useAppContext();
  const [libraryTiles, setLibraryTiles] = useState([]);

  useEffect(() => {
    let isMounted = true;
    getLibraryFolders(token)
      .then((folders) => {
        if (isMounted) setLibraryTiles(folders);
      })
      .catch(() => {});
    return () => {
      isMounted = false;
    };
  }, [token]);

  return (
    <main className="flex min-h-screen flex-col">
      <div className="h-[55vh] w-full overflow-hidden">
        <img
          src="/wallpaper/mat.png"
          alt=""
          className="h-full w-full object-cover object-[center_25%]"
        />
      </div>
      <div className="w-11/12 lg:w-10/12 mx-auto mb-10">
        <h1>{LibraryTrans[language].header}</h1>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-5 mt-8">
          {libraryTiles.map((tile) => (
            <Link
              key={tile.path}
              to={tile.path}
              className="group relative block aspect-square rounded-xl overflow-hidden bg-cover bg-center transition-transform duration-300 hover:scale-[1.02]"
              style={{ backgroundImage: `url(${tile.image})` }}
            >
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/15 transition-colors duration-300 ease-in-out" />
              <div className="relative h-full w-full flex items-center justify-center p-4 text-center text-base md:text-lg text-white font-medium">
                {language === "russian" ? tile.name.ru : tile.name.en}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Library;
